'use es6';

import { logCallingError } from 'calling-error-reporting/report/error';
export const LOCAL_SETTINGS_PREFIX = 'LocalSettings:Calling:';
function getPrefixedKey(key, prefix) {
  return `${prefix}${key}`;
}
export function setSetting(key, value, prefix = LOCAL_SETTINGS_PREFIX) {
  if (!window.localStorage) {
    return undefined;
  }
  try {
    if (typeof value === 'string') {
      window.localStorage.setItem(getPrefixedKey(key, prefix), value);
    } else {
      window.localStorage.setItem(getPrefixedKey(key, prefix), JSON.stringify(value));
    }
    return value;
  } catch (error) {
    return undefined;
  }
}
export function getSetting(key, fallback, parser, prefix = LOCAL_SETTINGS_PREFIX) {
  if (!window.localStorage) {
    return fallback;
  }
  try {
    const entry = window.localStorage.getItem(getPrefixedKey(key, prefix));
    if (!entry) {
      if (fallback) {
        setSetting(key, fallback);
      }
      return fallback;
    } else if (entry.startsWith('{')) {
      const result = JSON.parse(entry);
      return typeof parser === 'function' ? parser(result) : result;
    } else if (entry === 'null' || entry === 'undefined') {
      setSetting(key, fallback);
      return fallback;
    }
    return entry;
  } catch (error) {
    setSetting(key, fallback);
    logCallingError({
      errorMessage: 'Parsing LocalStorage value failed',
      extraData: {
        error
      }
    });
    return fallback;
  }
}